import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController } from 'ionic-angular';
import { User } from '../../providers/user';


/*
  Generated class for the AccountEmailForm component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'account-email-form',
  templateUrl: 'account-email-form.html'
})
export class AccountEmailFormComponent {
  account: { email?: string } = {
    email: this.user.fb.auth().currentUser.email
  };
  submitted = false;
  constructor(
    public user: User,
    public loading: LoadingController,
    public nav: NavController,
    public alert: AlertController,
  ) { }
  public onModify(form) {
    let loader = this.loading.create({
      content: 'Please wait..',
      duration: 10000
    });
    this.submitted = true;
    if (form.valid) {
      loader.present().then(() => {
        this.user.profile().updateEmail(this.account.email).then(() => {
          this.user.profileSync();  // persists on db
          loader.dismiss().then(() => {
            this.showAlert('Sucess', 'Your email has been changed.');
          });
        }, (e) => {
          loader.dismiss().then(() => {
            this.errorHandler(e);
          });
        });
      });
    }
  }

  showAlert(title, subtitle) {
    let alert = this.alert.create({
      title: title,
      subTitle: subtitle,
      buttons: ['OK']
    });
    return alert.present();
  }

  errorHandler(error) {
    let errorCode = error.code;
    let errorMessage = error.message;
    let handler = User.errorHandler(errorCode, errorMessage);
    this.showAlert(handler.title, handler.message);
  }
}


// WEBPACK FOOTER //
// ./src/components/account-email-form/account-email-form.ts